import { render, staticRenderFns } from "./tab-details-bullets-point.html?vue&type=template&id=c6490a00&scoped=true&"
import script from "./tab-details-bullets-point.js?vue&type=script&lang=js&"
export * from "./tab-details-bullets-point.js?vue&type=script&lang=js&"
import style0 from "./tab-details-bullets-point.css?vue&type=style&index=0&id=c6490a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6490a00",
  null
  
)

export default component.exports